import React, { PureComponent } from 'react'
import CarrierStatus from 'components/marketplace/CarrierStatus'
import PropTypes from 'prop-types'
import { PopoverLink } from 'components/PopoverLink'
import { CarrierPopoverCard } from './CarrierInfo'

export class CarrierPopover extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPopoverCard: false,
    }
  }

  toggleOn = () => {
    this.setState({ showPopoverCard: true })
  }

  toggleOff = () => {
    this.setState({ showPopoverCard: false })
  }

  render() {
    const { align, dataTest, displayStatus, hideStatus, id, legalName, status } = this.props
    const { showPopoverCard } = this.state
    const anchorParams = {
      href: `${__ROOT__}/carriers/${id}`,
      target: '_blank',
      'data-test': dataTest,
      rel: 'noopener noreferrer',
    }
    return (
      <div className='flex flex-row items-center'>
        <PopoverLink
          align={align}
          mouseEnterEvent={this.toggleOn}
          mouseLeaveEvent={this.toggleOff}
          anchorText={legalName}
          anchorParams={anchorParams}>
          <CarrierPopoverCard id={id} legalName={legalName} loadImmediately={showPopoverCard} />
        </PopoverLink>
        {!hideStatus && <CarrierStatus status={status} displayStatus={displayStatus} />}
      </div>
    )
  }
}

CarrierPopover.propTypes = {
  id: PropTypes.number.isRequired,
  legalName: PropTypes.string,
  status: PropTypes.string,
  dataTest: PropTypes.string,
  displayStatus: PropTypes.bool,
  align: PropTypes.oneOf(['top', 'bottom']),
  hideStatus: PropTypes.bool,
}

CarrierPopover.defaultProps = {
  legalName: '',
  status: '',
  dataTest: 'carrier-hoverable-link',
  displayStatus: false,
  align: 'top',
  hideStatus: false,
}
